<template>
    <main v-if="data && data.page">
        <article>
            <div class="heroCont">
                <div class="infoBar">
                    <WebsiteBreadcrumbs>
                        <a>publications</a>
                        <NuxtLink to="/publications/annual-reports">annual reports</NuxtLink>
                    </WebsiteBreadcrumbs>
                    <div class="date baron headerText" v-if="articleDate">
                        <span>{{ articleDate.getDate().toString().padStart(2, '0') }}</span>
                        <span>{{ (articleDate.getMonth() + 1).toString().padStart(2, '0') }}</span>
                        <span>{{ articleDate.getFullYear() }}</span>
                    </div>
                </div>
                <h1 class="helvetica title1">{{ data.page?.title }}</h1>
            </div>

            <div class="columns">
                <div class="bodyCont">
                    <BlockBody :body="data?.page.body" />
                </div>
                <BlockDownloads v-if="data?.page.attachment" :downloads="[data?.page.attachment]" />
            </div>
        </article>
        <WebsiteFooter />
    </main>
</template>

<script lang="ts" setup>
const { getAnnualReport } = usePublications();
const directusUrl = useDirectusUrl()
const route = useRoute()
const { data } = useAsyncData(`annual-report-${route.params.slug}`, () => getAnnualReport(route.params.slug));

const articleDate = computed(() => {
    if (data.value?.page && data.value.page.publication_date) return new Date(data.value.page.publication_date)
    else return null
})

useSeoMeta({
    title: () => `${data.value?.page?.title} | Annual Reports | Publications | EIC Federation`,
    ogTitle: () => `${data.value?.page?.title} | Annual Reports | Publications | EIC Federation`,
    twitterTitle: () => `${data.value?.page?.title} | Annual Reports | Publications | EIC Federation`,

    description: () => data.value?.page?.summary,
    ogDescription: () => data.value?.page?.summary,
    twitterDescription: () => data.value?.page?.summary,

    ogImage: () => data.value?.page?.cover?.id ? directusUrl + '/assets/' + data.value?.page.cover.id : undefined,
})
</script>

<style lang="scss" scoped>
main {
    article {
        padding: var(--size-padding-header) 0 var(--size-gutter-sections) 0;
        margin: 0 var(--size-margin-page);

        .infoBar {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-margin-page);

            margin-bottom: var(--size-gutter-default);
            color: var(--color-primary);

            .date {
                display: flex;
                gap: var(--size-gutter-default);
            }
        }

        h1 {
            margin-bottom: var(--size-gutter-double);
        }

        .columns {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);

            .bodyCont,
            .downloads,
            .tags {
                grid-column: 2;
            }
        }
    }
}

@media screen and (max-width: 1280px) {
    main article {
        .infoBar {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }

        .columns {
            display: flex;
            flex-direction: column;
            gap: var(--size-gutter-double);

            .imageCont {
                max-width: var(--text-maxwidth-body);
            }
        }
    }
}
</style>